<template>
  <div class="article-container d-flex pr-2 last:pr-0 px-lg-4 pb-4 article-item cursor-pointer" :class="{
      'first:pl-2': forceClass,
      'last:pl-2': forceClass,
      'pr-2': !forceClass,
      'last:pr-0': !forceClass
    }" @click="handleClick">
    <div class="card card-scroll box-shadow">
      <div class="grid-thumb position-relative">
        <div class="automation-news-article-image relative">
          <img class="img-fluid article-image ls-is-cached lazyload" :data-src="article.img_main" :alt="article.article_title" width="680" height="384" data-lazy="Article - Image - Main - Placeholder">
          <div v-if="article.image_credits" class="image-credits">{{article.image_credits}}</div>
        </div>
      </div>
      <div class="card-body">
        <div class="article-info flex items-center mb-4">
          <div class="article-author flex items-center">
            <div class="author-img">
              <img class="lazyload rounded-full" :data-src="article.author.author_image" width="32" height="32">
            </div>
            <div class="author-name pl-2">

              <a :href="article.author.path" v-if="article.author.path">
                {{article.author.display_name}}
              </a>

              <span v-else>
                {{article.author.display_name}}
              </span>
            </div>
          </div>
          <div class="article-reading-time ml-auto">
            {{article.read_time}} {{article.read_time_label}}
          </div>
        </div>
        <div class="article-title pb-2 pb-lg-2 pb-md-1">
          <a :href="article.path" class="">
            {{article.article_title}}
          </a>
        </div>
        <div class="article-short-description">
          {{article.short_description}}
        </div>
        <div class="article-footer row">
          <div class="col-12 footer-item publish-date">
            {{article.time_ago}}
            <span class="" v-if="article.country_name">| {{article.country_name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'article-item',
  props: {
    article: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      required: false,
    },
    forceClass: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      if (!event.target.closest('a')) {
        window.location.href = this.article.path;
      }
    },
  }
};
</script>
